import { PaymentSettingsFormErrorJSON } from '../models/payment-settings';

export const formPaymentSettingsErrors: PaymentSettingsFormErrorJSON = {
    paidToFacilityId: [
        {
            code: 'required',
            message: 'This field is required',
        },
        {
            code: 'pattern',
            message: 'Only letters and numbers are allowed',
        },
    ],
};
